import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import SickIcon from '@mui/icons-material/Sick';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { AbsenceKind } from 'src/types';
import themeColors from 'src/theme/colors';

import useStyles from './WeeklyBanner.styles';

interface Props {
  kind: AbsenceKind;
}

/** Weekly-view note marking an approved vacation or sick day at the top of a day column. */
const WeeklyAbsenceNote: FC<Props> = ({ kind }) => {
  const classes = useStyles();
  const { t } = useTranslation('translation', {
    keyPrefix: 'AbsenceBannerNote',
  });

  const Icon = kind === 'vacation' ? BeachAccessIcon : SickIcon;

  return (
    <Box className={clsx(classes.note, classes.blockTimeNote)}>
      <Typography color={themeColors.shade4} variant="h6">
        {t(kind)}
      </Typography>
      <Icon className={classes.blockTimeIcon} fontSize="inherit" />
    </Box>
  );
};

export default WeeklyAbsenceNote;
